import { IRootState } from '../../../store'

export const getSctProceduresOptionsSelector = (state: IRootState) => state.options.sctOptions.sctProcsOptions
